import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 40px;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  &:hover {
    background-color: #F7F7F7;
  }
`

export const ActionBlock = styled.div`
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  padding: 2px 6px;
  border-radius: 8px;
  color: #FFFFFF;
  font-weight: 500;
  background-color: ${({ action }) => {
    switch (action) {
      case 'create': return '#44CF6C'
      case 'update': return '#35A7FF'
      case 'delete': return '#E74C3C'
      default: return '#F2DEDE'
    }
  }};
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
  margin: 0px;
  align-self: center;
`
